import { useState, useEffect } from "react";
import { assinaturaService } from "../services/assinaturaService";
import { Assinatura } from "../interfaces/Assinatura";

type FetchAssinaturasOptions =
  | boolean
  | {
      showLoading?: boolean;
      preserveOnEmpty?: boolean;
    };

export const useAssinaturas = () => {
  const [assinaturas, setAssinaturas] = useState<Assinatura[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchAssinaturas = async (options: FetchAssinaturasOptions = true) => {
    const showLoading =
      typeof options === "boolean" ? options : options.showLoading ?? true;
    const preserveOnEmpty =
      typeof options === "boolean" ? false : options.preserveOnEmpty ?? false;

    if (showLoading) {
      setIsLoading(true);
    }

    try {
      const data = await assinaturaService();
      const assinaturasAtualizadas = Array.isArray(data) ? data : [];

      setAssinaturas((assinaturasAtuais) => {
        if (
          preserveOnEmpty &&
          assinaturasAtuais.length > 0 &&
          assinaturasAtualizadas.length === 0
        ) {
          return assinaturasAtuais;
        }

        return assinaturasAtualizadas;
      });

      return assinaturasAtualizadas;
    } finally {
      if (showLoading) {
        setIsLoading(false);
      }
    }
  };

  const upsertAssinatura = (assinatura: Assinatura) => {
    setAssinaturas((assinaturasAtuais) => {
      const outrasAssinaturas = assinaturasAtuais.filter(
        (item) => item.id !== assinatura.id
      );

      return [assinatura, ...outrasAssinaturas];
    });
  };

  useEffect(() => {
    fetchAssinaturas(true);
  }, []);

  return { assinaturas, isLoading, fetchAssinaturas, upsertAssinatura };
};
